import { useQueryClient } from "@tanstack/react-query"

import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"
import { campaignQueryKeys } from "@l2r-front/l2r-shared-campaign"

import { useCampaignMutation } from "./useCampaignMutation"

type DeleteCampaignConfig = {
    errorSnackbarMessage?: string
    onSuccess?: (data: any) => void
    onError?: (error: any) => void
    successSnackbarMessage?: string
}

export function useCampaignDelete(
    campaignId: string,
    queryParameters = {},
    config = {
        errorSnackbarMessage: null,
        onSuccess: null,
        successSnackbarMessage: null,
    } as DeleteCampaignConfig,
) {
    const url = `campaigns/${campaignId}/`
    const queryClient = useQueryClient()

    return useCampaignMutation(
        url,
        axiosInstance.delete,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                config.onSuccess?.(data)
                const queryKey = campaignQueryKeys["list"]()
                queryClient.invalidateQueries(queryKey as any)
            },
        },
    )
}